document.addEventListener("DOMContentLoaded", function () {
  // Select DOM elements
  let mainButton = document.querySelector("#AddonProductModalOpener");
  let dummyButtonATC = document.querySelector(".dummy-atc-button");
  
  // Function to toggle loader on buttons
  function toggleLoader(button, showLoader) {
    const buttonContent = button.querySelector(".custom-atc-btn");
    const spinner = button.querySelector(".loading__spinner");

    button.disabled = showLoader;
    if (buttonContent) buttonContent.style.display = showLoader ? "none" : "block";
    if (spinner) spinner.classList.toggle("hidden", !showLoader);
  }

  // Function to update mobile sticky bar button based on city availability
  function updateMobileButtonState(isCityAvailable, selectedCity) {
    if (!dummyButtonATC) return;
    
    // Get all custom-atc-btn spans (there are two: one for icon, one for text)
    const buttonSpans = dummyButtonATC.querySelectorAll('.custom-atc-btn');
    if (buttonSpans.length < 2) return;
    
    const iconSpan = buttonSpans[0]; // First span contains the icon
    const textSpan = buttonSpans[1]; // Second span contains the text
    
    if (isCityAvailable) {
      // Enable button and show "Add to Cart"
      dummyButtonATC.disabled = false;
      dummyButtonATC.classList.remove('disabled');
      dummyButtonATC.removeAttribute('aria-disabled');
      
      // Show icon and "Add to Cart" text
      // Restore the original icon (we'll store it initially)
      if (window.originalIconHTML) {
        iconSpan.innerHTML = window.originalIconHTML;
      }
      textSpan.textContent = (window.translations && window.translations.add_to_cart) || 'Add to Cart';
    } else {
      // Disable button and show city unavailable message
      dummyButtonATC.disabled = true;
      dummyButtonATC.classList.add('disabled');
      dummyButtonATC.setAttribute('aria-disabled', 'true');
      
      // Use translation with proper city name
      const isArabic = document.documentElement.lang === 'ar';
      const displayCityName = getCityDisplayName(selectedCity, isArabic);
      const translationText = isArabic ? 
        `غير متوفر في ${displayCityName}` : 
        `Not Available in ${displayCityName}`;
      
      // Hide icon and show only the unavailable message
      iconSpan.innerHTML = '';
      textSpan.textContent = translationText;
    }
  }

  // Function to get city display name (similar to product-form.js)
  function getCityDisplayName(cityName, isArabic) {
    // Use global CityMatcher if available, otherwise fallback to local logic
    if (window.CityMatcher && window.CityMatcher.getCityDisplayName) {
      return window.CityMatcher.getCityDisplayName(cityName, isArabic);
    }
    
    // Fallback to original city name
    return cityName;
  }

  // Listen for city availability changes from product-form
  document.addEventListener('city-availability-changed', (event) => {
    if (event.detail) {
      updateMobileButtonState(event.detail.isAvailable, event.detail.selectedCity);
    }
  });

  // Also listen for city change events
  document.addEventListener('city-changed', (event) => {
    // Trigger a check by dispatching a custom event that product-form will handle
    // The product-form will then dispatch city-availability-changed which we listen to above
    setTimeout(() => {
      const productForm = document.querySelector('product-form');
      if (productForm && productForm.checkCityAvailability) {
        productForm.checkCityAvailability();
      }
    }, 100);
  });

  // Initialize mobile button state on page load
  function initializeMobileButtonState() {
    const productForm = document.querySelector('product-form');
    if (productForm && productForm.getCityAvailabilityStatus) {
      const status = productForm.getCityAvailabilityStatus();
      updateMobileButtonState(status.isAvailable, status.selectedCity);
    }
  }

  // Store original icon HTML for restoration
  if (dummyButtonATC) {
    const iconSpan = dummyButtonATC.querySelector('.custom-atc-btn');
    if (iconSpan) {
      window.originalIconHTML = iconSpan.innerHTML;
    }
  }

  // Initialize on page load
  setTimeout(initializeMobileButtonState, 500);

  // Periodic check to ensure mobile button stays in sync (fallback mechanism)
  setInterval(() => {
    const productForm = document.querySelector('product-form');
    if (productForm && productForm.getCityAvailabilityStatus) {
      const status = productForm.getCityAvailabilityStatus();
      const currentCity = productForm.dataset.city;
      
      // Only update if we have a valid city and the button exists
      if (currentCity && dummyButtonATC) {
        updateMobileButtonState(status.isAvailable, currentCity);
      }
    }
  }, 2000); // Check every 2 seconds

  // Sync dummy ATC button with Main ATC button (It also handles loader, redirect and quantity sync)
  if (dummyButtonATC) {
    dummyButtonATC.addEventListener("click", () => {
      try {
        toggleLoader(dummyButtonATC, true);
        setTimeout(() => {
          if (mainButton) {
            mainButton.click();
          }
          toggleLoader(dummyButtonATC, false);
        }, 3000);
      } catch (error) {
        console.error("Error in Add to Cart process:", error);
        toggleLoader(dummyButtonATC, false);
      }
    });
  }
});